import { algoliaConfig } from "@/services/algolia/config";
import { PopularSearchItem } from "./types/algolia";

export const ALGOLIA_STORE_AROUND_RADIUS = 1000000000;
export const MEALS_LIMIT = 10;
export const defaultBannerCode = process.env.NEXT_PUBLIC_BANNER;

export const CACHE_KEYS = {
  MULESOFT_TOKEN: "MULESOFT_TOKEN",
  MULESOFT_OFFER: "MULESOFT_OFFER",
  ALGOLIA_POPULAR_SEARCHES:
    "ALGOLIA_POPULAR_SEARCHES_" + process.env.NEXT_PUBLIC_BANNER,
  ALGOLIA_POPULAR_DATA: (storeId: string) =>
    ("ALGOLIA_POPULAR_DATA_" + storeId) as "ALGOLIA_POPULAR_DATA",
  RECENT_SEARCHES: (userId: string) =>
    ("RECENT_SEARCHES_" +
      process.env.NEXT_PUBLIC_BANNER +
      "_" +
      userId) as "RECENT_SEARCHES",
  AVAILABLE_PRODUCT_CATEGORIES: "AVAILABLE_PRODUCT_CATEGORIES",
} as const;

export const CACHE_TTL = {
  MULESOFT_TOKEN_EXPIRY: 55 * 60, // 55 MIN
  MULESOFT_OFFER_EXPIRY: 3600 * 12, // 12 HOURS
  POPULAR_SEARCH: 3600 * 24, // 24 HOURS
  POPULAR_DATA: 3600 * 24, // 24 HOURS
  RECENT_SEARCHES: 3600 * 24 * 30, // 30 DAYS
  AVAILABLE_PRODUCT_CATEGORIES: 3600 * 6, // 6 HOURS
};

export const USER_DIETARY_PREFERENCE_KEYS = [
  "glutenFree",
  "vegan",
  "lactoseFree",
  "vegetarian",
  "kosher",
];

export const RECIPES_ARTICLES_DIETARY_PREFERENCE_MAPPING: Record<
  string,
  string
> = {
  glutenFree: "Gluten Free",
  vegan: "Vegan",
  lactoseFree: "Lactose Free",
  vegetarian: "Vegetarian",
  kosher: "Kosher",
};

export const GLOBAL_SEARCH_QUERY_PARAM_KEY = "query";
export const SEARCH_RESULT_TAB_QUERY_PARAM_KEY = "tab";

export const LOCAL_STORAGE_KEYS = {
  STORE_ID: "store",
  GEOLOCATION: "userLocation",
  ANONYMOUS_USER: "gurt-323s-kl43m-k43fd",
  RECENT_SEARCH: "recentSearches",
};

export const PAGE_SECTION = {
  RECIPE_DETAILS_SECTION: "RECIPE_DETAILS",
  RECIPE_POPUP_MODEL_SECTION: "RECIPE_POPUP_MODEL_DATA",
  RECIPE_FOR_YOU: "RECIPE_FOR_YOU",
  MEAL_PLAN_PAGE_SECTION: "MEAL_PLAN_PAGE_SECTION",
  MEAL_PLAN_POPUP_SECTION: "MEAL_PLAN_POPUP_SECTION",
  RECIPE_AEM_DATA: "RECIPE_AEM_DATA",
  // RECIPE_PAGE_SECTION = "re"
};
export enum GLOBAL_SEARCH_RESULTS_SECTIONS {
  PRODUCT = "products",
  RECIPE = "recipes",
  ARTICLE = "articles",
}
export const SEARCH_DROPDOWN_MAX_QUICK_LINKS_RESULTS_COUNT = 5;

export const MIN_VALID_POPULAR_SEARCHES_LENGTH = 3;

export const FALLBACK_POPULAR_SEARCH_ITEMS: PopularSearchItem[] = [
  {
    search: "Milk",
    count: 1,
    nbHits: 1,
  },
  {
    search: "Cheese",
    count: 1,
    nbHits: 1,
  },
  {
    search: "Salted Snacks",
    count: 1,
    nbHits: 1,
  },
  {
    search: "Soft Drinks",
    count: 1,
    nbHits: 1,
  },
  {
    search: "Gift Cards",
    count: 1,
    nbHits: 1,
  },
  {
    search: "Local and Canadian",
    count: 1,
    nbHits: 1,
  },
];
export const USER_PREFERENCE = ["Vegetarian", "Vegan"];

export const ATTRIBUTES_TO_RETRIEVE = [
  "objectID",
  "title",
  "recipeInstructions",
  "description",
  "recipeTags",
  "steps",
  "featuredImage",
  "cooking",
  "pageSlug",
];

export const DEFAULT_RECIPE_NUMBER = 20;

export const DEFAULT_ARTICLE_NUMBER = 20;

export const AUTHENTICATE = "AUTHENTICATE_USER";

export const UNAUTHENTICATE = "UNAUTHENTICATE_USER";

export const RECIPETAG = "recipeTags";

export const MOBILE_LIST = "mobile-lists";

export const RESET_FILTERS = "resetFilters";

export const TIME_ZONE = "America/Toronto";

export const TIME_ZONE_LOCALE = "en-CA";

export const MEAL_PLAN_TIME_ZONE = "America/Toronto";

export const MEAL_PLAN_TIME_ZONE_LOCALE = "en-CA";

export const FLYER_VIEWS = {
  LIST: "list",
  VIEW: "view",
};
export const FLYER_ROUTES = {
  FLYER_PRODUCT: "/flyer/product",
  FLYER: "/flyer",
};
export const DEFAULT_SORT_LABEL = "Select Sorting...";

export const ALL_PRODUCTS = "All products";

export const PRODUCTS = "products";

export const ITEMS_PER_PAGE = "itemsPerPage";

export const INVALID_STORE_CODE = "422";

export const TAB = "tab";

export const WEEKLY_FLYER = "weekly";

export const RECIPE_FILTERS_ATTRIBUTES = [
  "cooking.skillLevel",
  "cooking.totalTime",
  "ingredients.ingredient",
  "nutrition_info.healthcheck",
  "pageSlug",
  "recipeTags",
];

export const SORT_ORDER = [
  { attribute: "recipeTags", name: "Tags" },
  { attribute: "cooking.skillLevel", name: "Skill Level" },
  { attribute: "cooking.totalTime", name: "Total Time" },
  { attribute: "recipeCategories", name: "Categories" },
  { attribute: "attributes.meal-type", name: "Meal Type" },
  { attribute: "attributes.cuisine", name: "Cuisine" },
  { attribute: "attributes.dietary-needs", name: "Dietary Needs" },
  { attribute: "attributes.quick-easy-meals", name: "Quick Easy Meals" },
  { attribute: "attributes.preparation-method", name: "Preparation Method" },
  { attribute: "attributes.dish", name: "Dish" },
  { attribute: "attributes.drinks", name: "Drinks" },
  { attribute: "attributes.seasonal", name: "Seasonal"},
];
export const webBaseUrl = process.env.NEXT_PUBLIC_BASE_URL;

export const PRODUCT_FILTERS = [
  { attribute: "brand", name: "Brands" },
  { attribute: "allergens.alcohol", name: "Alcohol" },
  { attribute: "allergens.eggFree", name: "Egg-free" },
  { attribute: "allergens.glutenFree", name: "Gluten-free" },
  { attribute: "allergens.halal", name: "Halal" },
  { attribute: "allergens.kosher", name: "Kosher" },
  { attribute: "allergens.lactoseFree", name: "Lactose-free" },
  { attribute: "allergens.milkFree", name: "Milk-free" },
  { attribute: "allergens.mustardFree", name: "Mustard-free" },
  { attribute: "allergens.nutFree", name: "Nut-free" },
  { attribute: "allergens.oatFree", name: "Oat-free" },
  { attribute: "allergens.organic", name: "Organic" },
  { attribute: "allergens.peanutFree", name: "Peanut-free" },
  { attribute: "allergens.sesameFree", name: "Sesame-free" },
  { attribute: "allergens.shellfishFree", name: "Shellfish-free" },
  { attribute: "allergens.soyaFree", name: "Soy-free" },
  { attribute: "allergens.sulphitesFree", name: "Sulphite-free" },
  { attribute: "allergens.vegan", name: "Vegan" },
  { attribute: "allergens.vegetarian", name: "Vegetarian" },
  { attribute: "allergens.wheatFree", name: "Wheat-free" },
  { attribute: "allergens.tobacco", name: "Tobacco" },
  { attribute: "promotions.startDate", name: "FlyerStartDate" },
  { attribute: "promotions.endDate", name: "FlyerEndDate" },
  {
    attribute: "promotions.promotionComplianceFlag",
    name: "FlyerComplianceFlag",
  },
  { attribute: "promotions.source", name: "FlyerSource" },
];

export const ARTICLES_FILTER = [
  { attribute: "filter", name: "Filter 1" },
  { attribute: "filter.1", name: "Filter 2" },
  { attribute: "filter.2", name: "Filter 3" },
];

export const widthSizes = {
  fullWidthBannerData: 992,
};

export const SEARCH_TERM_STATIC_TEXT_FROM_AEM = "{searchTerm}";
export const RESULT_COUNT_STATIC_TEXT_FROM_AEM = "{resultCount}";

export const AemHost = process.env.NEXT_PUBLIC_AEM_PATH_URL;

export const SALESFORCE_CLIENT_ID = process.env.SALESFORCE_CLIENT_ID;
export const SALESFORCE_CLIENT_SECRET = process.env.SALESFORCE_CLIENT_SECRET;
export const SALESFORCE_ACCOUNT_ID = process.env.SALESFORCE_ACCOUNT_ID;
export const SALESFORCE_TOKEN_URL = process.env.SALESFORCE_TOKEN_URL;
export const SALESFORCE_POST_URL = process.env.SALESFORCE_POST_URL;
export const BANNER_NAME = process.env.NEXT_PUBLIC_HOME_BANNER;

export const RecipeImage =
  `${process.env.NEXT_PUBLIC_PROTOCOL}` +
  "://" +
  process.env.NEXT_PUBLIC_AEM_IMAGE_API_URL;

export const GigyaScreenSet = {
  profile: {
    screenset: `${process.env.NEXT_PUBLIC_DEFAULT_BANNER}-ProfileUpdate${process.env.NEXT_PUBLIC_DXP_SCREENSET_SUFFIX}`,
    page: "gigya-update-profile-screen",
  },
  changePassword: {
    screenset: `${process.env.NEXT_PUBLIC_DEFAULT_BANNER}-RegistrationLogin${process.env.NEXT_PUBLIC_DXP_SCREENSET_SUFFIX}`,
    page: "gigya-reset-password-screen",
  },
  subscription: {
    screenset: `${process.env.NEXT_PUBLIC_DEFAULT_BANNER}-LiteRegistration${process.env.NEXT_PUBLIC_DXP_SCREENSET_SUFFIX}`,
    page: "gigya-subscribe-with-email-screen",
  },
  addcardScreen: {
    screenset: `${process.env.NEXT_PUBLIC_DEFAULT_BANNER}-ProfileUpdate${process.env.NEXT_PUBLIC_DXP_SCREENSET_SUFFIX}`,
    page: "gigya-add-card-screen",
  },
  preferencesCentre: {
    screenset: `${process.env.NEXT_PUBLIC_DEFAULT_BANNER}-ProfileUpdate${process.env.NEXT_PUBLIC_DXP_SCREENSET_SUFFIX}`,
    screen: [
      {
        title: "Email Preferences",
        page: "email-preferences-screen",
        icon: "icon-email",
      },
      {
        title: "Store Communications",
        page: "other-email-preferences-screen",
        icon: "icon-settings",
      },
      {
        title: "Shopping Preferences",
        page: "category-preferences-screen",
        icon: "icon-bag",
      },
      {
        title: "Lifestyle Preferences",
        page: "lifestyle-preferences-screen",
        icon: "icon-lifestyle",
      },
      {
        title: "Pharmacy and Wellness Preferences",
        page: "pharmacy-prefernces-screen",
        icon: "icon-spa",
      },
      {
        title: "Dietary Preferences and Restrictions",
        page: "dietary-preferences-screen",
        icon: "icon-dining",
      },
      {
        title: "Household",
        page: "household-preferences-screen",
        icon: "icon-house",
      },
    ],
  },
};

export const DEFAULT_SEARCH_PAGE_SORTING = "Relevance";

export const PRODUCT_FILTERS_ATTRIBUTES = [
  { attribute: "hierarchicalCategories.lvl0", name: "Level1" },
  { attribute: "hierarchicalCategories.lvl1", name: "Level2" },
  { attribute: "hierarchicalCategories.lvl2", name: "Level3" },
];

export const CLEAR_ALL_PRODUCT_ATTRIBUTES = [
  { attribute: "allergens.alcohol", name: "Alcohol" },
  { attribute: "allergens.eggFree", name: "Egg-free" },
  { attribute: "allergens.glutenFree", name: "Gluten-free" },
  { attribute: "allergens.halal", name: "Halal" },
  { attribute: "allergens.kosher", name: "Kosher" },
  { attribute: "allergens.lactoseFree", name: "Lactose-free" },
  { attribute: "allergens.milkFree", name: "Milk-free" },
  { attribute: "allergens.mustardFree", name: "Mustard-free" },
  { attribute: "allergens.nutFree", name: "Nut-free" },
  { attribute: "allergens.oatFree", name: "Oat-free" },
  { attribute: "allergens.organic", name: "Organic" },
  { attribute: "allergens.peanutFree", name: "Peanut-free" },
  { attribute: "allergens.sesameFree", name: "Sesame-free" },
  { attribute: "allergens.shellfishFree", name: "Shellfish-free" },
  { attribute: "allergens.soyaFree", name: "Soy-free" },
  { attribute: "allergens.sulphitesFree", name: "Sulphite-free" },
  { attribute: "allergens.vegan", name: "Vegan" },
  { attribute: "allergens.vegetarian", name: "Vegetarian" },
  { attribute: "allergens.wheatFree", name: "Wheat-free" },

  { attribute: "price", name: "Price" },
];

export const PRODUCT_ALLERGENS_MAPPING = {
  alcohol: "Alcohol",
  eggFree: "Egg-free",
  glutenFree: "Gluten-free",
  halal: "Halal",
  kosher: "Kosher",
  lactoseFree: "Lactose-free",
  milkFree: "Milk-free",
  mustardFree: "Mustard-free",
  nutFree: "Nut-free",
  oatFree: "Oat-free",
  organic: "Organic",
  peanutFree: "Peanut-free",
  sesameFree: "Sesame-free",
  shellfishFree: "Shellfish-free",
  soyaFree: "Soy-free",
  sulphitesFree: "Sulphite-free",
  vegan: "Vegan",
  vegetarian: "Vegetarian",
  wheatFree: "Wheat-free",
  tobacco: "Tobacco",
} as const;

export const ARTICAL_CATEGORIES = [{ attribute: "category" }];

export const SHORTING_RECIPES = [
  {
    label: "Alphabetical: A-Z",
    value: algoliaConfig.indexNames.recipeSort.titleAsc,
  },
  {
    label: "Alphabetical: Z-A",
    value: algoliaConfig.indexNames.recipeSort.titleDesc,
  },
  {
    label: "Newest Date",
    value: algoliaConfig.indexNames.recipeSort.newestDate,
  },
  {
    label: "Oldest Date",
    value: algoliaConfig.indexNames.recipeSort.oldestDate,
  },
  { label: "Relevance", value: algoliaConfig.indexNames.recipes },
];
export const SHORTING_ARTICLE = [
  { label: "Relevance", value: algoliaConfig.indexNames.articles },
  {
    label: "Alphabetical: A-Z",
    value: algoliaConfig.indexNames.articleSort.titleAsc,
  },
  {
    label: "Alphabetical: Z-A",
    value: algoliaConfig.indexNames.articleSort.titleDesc,
  },
  {
    label: "Newest Date",
    value: algoliaConfig.indexNames.articleSort.newestDate,
  },
  {
    label: "Oldest Date",
    value: algoliaConfig.indexNames.articleSort.oldestDate,
  },
];
export const SHORTING_PRODUCTS = [
  { label: "Relevance", value: algoliaConfig.indexNames.products },
  {
    label: "Alphabetical: A-Z",
    value: algoliaConfig.indexNames.productSort.titleAsc,
  },
  {
    label: "Alphabetical: Z-A",
    value: algoliaConfig.indexNames.productSort.titleDesc,
  },
  {
    label: "Price: Low to High",
    value: algoliaConfig.indexNames.productSort.newestDate,
  },
  {
    label: "Price: High to Low",
    value: algoliaConfig.indexNames.productSort.oldestDate,
  },
];

export const CDP_EVENTS = {
  screenClassFlyer: "https://dxp-dev.sobeys.com/flyer/",
  screenClassHomeLogo: "https://sobeys.ca/",
  screenClassHeader: "https://dxp-dev.sobeys.com/",
};

export const MESSAGE = {
  LOGIN_MESSAGE: `Heads up! Your "Add to Favorite" and "Add to List" actions will not be saved unless you are signed in.`,
  RECIPE_ADDED_TO_LIST: "Your recipe was successfully added to list(s)",
  RECIPE_REMOVE_TO_LIST: "Your recipe was successfully removed to lists",
  LIST_NAME_EXIST: "List name already exists",
  MERGE_SUCCESSFULL: "Recipe Lists merged successfully",
  RECIPE_DELETED: "Recipes has been deleted successfully",
  RECIPE_LIST_DELETED: "Recipe list has been deleted successfully",
  RECIPE_LIST_UPDATE: "Your recipe list was updated successfully",
  RECIPE_LIST_CREATE: "Your recipe list has been create successfully",

  ERROR_MESSAGE: {
    INITIAL_SPACE_ERROR: "Initial spaces are not allowed.",
    BEGIN_ERROR_MESSAGE:
      "The name must not begin with an underscore (_) or hyphen (-).",
    END_ERROR_MESSAGE:
      "The name must not end with an underscore (_) or hyphen (-).",
    LIST_NAME_EMPTY_MESSAGE: "List name cannot be empty.",
    LIST_NAME_MIN_CHARACTERS: "List name must be of minimum 3 characters.",
    LIST_NAME_MAX_CHARACTERS: "List name must be of maximum 20 characters.",
    SPECIAL_CHARACTER_NOT_ALLOWED: "Special Character not allowed.",
    RECIPE_LIST_ALREADY_EXIST: "Recipe list name already exists",
  },
};

export const AEM_LAYOUT_PATH = {
  SUMMER: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/summer.model.json`,
  ROAST_CALCULATOR: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/roast-calculator.model.json`,
  GRILLING_GUIDE: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/grilling-guide.model.json`,
  PROVINCIAL_PRIVACY_OFFICES: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/provincial-privacy-offices.model.json`,
  TERMS_AND_CONDITIONS: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/terms-and-conditions.model.json`,
  PRIVACY_POLICY: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/privacy-policy.model.json`,
  OUR_RECIPE_PROMISE: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/our-recipe-promise.model.json`,
  PROMOTION_MOBILE: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/mobile.model.json`,
  VERIFIED_PRICES: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/verified-prices.model.json`,
  SCENE_PLUS_FAQ: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/sceneplus/faq.model.json`,
  SCENE_PLUS: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/sceneplus.model.json`,
  FOOD_RESCUE: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/foodhero-rescue.model.json`,
  FOOD_HERO: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/foodhero.model.json`,
  READY_FOR_YOU: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/ready-for-you.model.json`,
  READY_FOR_YOU_SINGLE: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/ready-for-you/details.model.json`,
  ACCESSIBILITY: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/accessibility.model.json`,
  VALUE_FLYER: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/value-flyer.model.json`,
  SEASONAL: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/seasonal.model.json`,
  TIMELINE: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/sobeys-110-timeline.model.json`,
  COMMUNITY_ACTION_FUND: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/community-action-fund.model.json`,
  SUPPORTING_WOMEN_OWNED: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/supporting-women-owned-business.model.json`,
  GIFT_CARD_EVERY_OCCASSION: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/gift-cards-for-every-occasion.model.json`,
  BULK_GIFT_CARD_PROGRAM: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/gift-cards-for-every-occasion/bulk-gift-cards.model.json`,
  RACHELLEBERY: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/rachelle-bery.model.json`,
  MAKE_GIFTING_A_BREEZE: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/gift-cards-for-every-occasion/gifting-options.model.json`,
  FOODHERO_RULES: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/foodhero/foodhero-rules.model.json`,
  MAINTENANCE: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/site-maintenance.model.json`,
  LOCAL_SUPPLIER: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/local-supplier-engagement.model.json`,
  FAQ: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/entertaining/faq.model.json`,
  ENTERTAINING: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/entertaining.model.json`,
  VOILA_SOBEYS_DELIVERY: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/voila-by-sobeys-grocery-delivery.model.json`,
  COMPLIMENTS: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}//en/compliments.model.json`,
  CONTESTS: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/contests.model.json`,
  PANACHE: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/panache.model.json`,
  RICARDO: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/ricardo.model.json`,
  FAQS: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/faqs.model.json`,
  VIDEO: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/videos.model.json`,
  CONTEST_DETAIL: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/contests/`,
  ARTICLES: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/articles.model.json`,
  ARTICLE_DETAIL: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/articles/article-detail.model.json`,
  BAKE_SHOP: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/bake-shop.model.json`,
  CELEBRATION_CAKE: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/celebration-cakes.model.json`,
  STERLING_SILVER: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/sterling-silver.model.json`,
  PRODUCT_DETAIL: `/graphql/execute.json/empire-${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/productDetailPage`,
  PRODUCT_LISTING: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/products.model.json`,
  SHOPPING_DETAIL: `content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/shopping-list.model.json`,
  SHOPPING_LIST: `graphql/execute.json/empire-${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/shoppingListPageContent`,
  SLUG_PAGE: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/`,
  RECIPE_AEM_DATA: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/recipes.model.json`,
  RECIPE_COLLECTION: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/collections.model.json`,
  RECIPE_COLLECTION_DETAIL: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/collections/recipe-collection-detail.model.json`,
  OFFERS_PAGE: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/offers.model.json`,
  FLYERS_PAGE: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/flyer.model.json`,
};

export const AEM_DATA_PATH = {
  ROAST_CALCULATOR: `graphql/execute.json/empire-${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/getAllRoastRecipes`,
  READY_FOR_YOU: `graphql/execute.json/empire-${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/getReadyForYouDetails`,
  VIDEO: `/graphql/execute.json/empire-${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/getAllVideos?chache`,
  COLLECTION: `/graphql/execute.json/empire-${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/getAllCollections`,
  RECIPE_DETAILS_PATH: `/graphql/execute.json/empire-${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/recipeDetailLabels`,
  RECIPE_POPUP_MODEL_LIST_PATH: `graphql/execute.json/empire-${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/recipePopUpLabels`,
  NEXT_RECIPE_LIST_PATH: `/content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/recipes.model.json`,
  AEM_HOME_PAGE_PATH: `content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en.model.json`,
  AEM_MEAL_PLAN_PAGE_PATH: `/graphql/execute.json/empire-${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/mealPlanMainContent`,
  AEM_MEAL_PLAN_POPUP_PATH: `/graphql/execute.json/empire-${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/mealPlanPopupContent`,
  HEADER_DATA: `content/experience-fragments/empire-${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/site/header/master.model.json`,
  FOOTER_DATA: `content/experience-fragments/empire-${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/site/footer/master.model.json`,
  SUBSCRIPTION_DETAILS: `graphql/execute.json/empire-${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/subscriptionPageContent`,
  SCENE_PLUS_DETAILS: `graphql/execute.json/empire-${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/getAllImageandContentList`,
  STORE_LOCATOR_DETAILS: `graphql/execute.json/empire-${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/storeLocatorContent`,
  GUIDANCE_DETAILS: `graphql/execute.json/empire-${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/getSobeysGuidanceData`,
};

export const Recipe_list_name = "Favourites";
export const DEFAULT_RECIPE_FILTER = `bannerCode:${process.env.NEXT_PUBLIC_DEFAULT_BANNER}`;
export const ORIGIN = process.env.NEXT_PUBLIC_BASE_URL;
export const DEFAULT_ARTICLE_FILTER = `bannerCode:${process.env.NEXT_PUBLIC_DEFAULT_BANNER}`;
export const WEB_META_TITLE = process.env.NEXT_PUBLIC_WEB_META_TITLE;
export const DEFAULT_BANNER = process.env.NEXT_PUBLIC_DEFAULT_BANNER;

export const BB_OFFER_TYPE = [19, 20, 21];
export const defaultSlidesPerView = {
  articles: { base: 1, sm: 1.2, md: 2.2, lg: 3.2, xl: 3, xxl: 4 },
  products: { base: 1, sm: 2.3, md: 3.3, lg: 4.5, xl: 4, xxl: 6 },
  recipes: { base: 1, sm: 1.5, md: 2.5, lg: 3.5, xl: 3, xxl: 4 },
};

export const NO_FILTERED_RESULTS_PROP_FOR_POPULAR_PRODUCTS_SLIDER = {
  type: GLOBAL_SEARCH_RESULTS_SECTIONS.PRODUCT,
  title: "Popular Products",
  titleCTA: "View All",
  slideCount: 18,
  showControls: true,
  slidesPerView: { base: 1, sm: 2, md: 3, lg: 3, xl: 4, xxl: 5 },
};
export const NO_FILTERED_RESULTS_PROP_FOR_POPULAR_PRODUCTS_SLIDER_FAVOURITES = {
  ...NO_FILTERED_RESULTS_PROP_FOR_POPULAR_PRODUCTS_SLIDER,
  slidesPerView: { base: 1.6, sm: 2.1,ssm: 2.5, md: 3.3, lg: 4, xl: 4, xml: 5, xxl: 6 },
};

export const NO_FILTERED_RESULTS_PROP_FOR_POPULAR_PRODUCTS_SLIDER_Favorites = {
  type: GLOBAL_SEARCH_RESULTS_SECTIONS.PRODUCT,
  title: "Popular Products",
  titleCTA: "View All",
  slideCount: 18,
  showControls: true,
  slidesPerView: { base: 1.6, sm: 2.1,ssm: 2.5, md: 3.3, lg: 4, xl: 4, xml: 5, xxl: 6 },
};


export const FAVOURITES = "Favourites";

export const NO_ALCOHOL_STORES = [
  "Alberta",
];

export const REMOVETAG = [
  "Christmas",
  "Italian",
  "Soup",
  "Sauces",
  "Fall",
  "Turkey",
  "Thanksgiving",
  "Mexican",
  "Rice",
  "Winter",
  "Slow Cooker",
  "Pie",
  "New Year's",
  "Hot Drinks",
  "Middle Eastern",
  "Dressings",
  "Thai",
  "Greek",
  "Halloween",
  "Sheet Pan Dinners",
  "Curry",
  "Indian",
  "Chinese",
  "French",
  "Smoothies",
  "Lamb",
  "Easter",
  "Juice",
  "Spring",
  "Mid-Autumn Festival",
  "Affordable",
];

export const TIME_RANGE = [
  {
    label: "15 minutes or less",
    value: "%7B%22end%22:15%7D",
    end: 15,
    isRefined: false,
  },
  {
    label: "30 minutes or less",
    value: "%7B%22end%22:30%7D",
    end: 30,
    isRefined: false,
  },
  {
    label: "45 minutes or less",
    value: "%7B%22end%22:45%7D",
    end: 45,
    isRefined: false,
  },
  {
    label: "1 hour or less",
    value: "%7B%22end%22:60%7D",
    end: 60,
    isRefined: false,
  },
];
export const getShareUrls = (
  shareUrl: string,
  shareText: string,
  mediaParam: string = ""
): Record<string, string> => {
  return {
    email: `mailto:?subject=Check this deal out on Sobeys&body=${shareText}%0A${shareUrl}`,
    pinterest: `https://pinterest.com/pin/create/button/?url=${shareUrl}&description=${shareText}${mediaParam}&method=button`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`,
    twitter: `https://twitter.com/intent/tweet?url=${shareUrl}&text=${shareText}`,
    instagram: `https://www.instagram.com/`,
    whatsapp: `https://api.whatsapp.com/send?text=${shareText}%20${shareUrl}`,
  };
};

export const CARD_STATUS_MAPPING = {
  LP00: "stack",
  LP01: "map",
  LP02: "enqueue",
  LP03: "dequeue",
};

export const REVERSE_CARD_STATUS = {
  stack: "LP00",
  map: "LP01",
  enqueue: "LP02",
  dequeue: "LP03",
};

export const APIRevalidateTag = {
  AEMAPI: "AEM-revalidate",
};

export type TPromotionKeys = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export const PromotionKeys = {
  1: "hidePromotionType1",
  2: "hidePromotionType2",
  3: "hidePromotionType3",
  4: "hidePromotionType4",
  5: "hidePromotionType5",
  6: "hidePromotionType6",
  7: "hidePromotionType7",
  8: "hidePromotionType8",
  9: "hidePromotionType9",
  10: "hidePromotionType10",
  11: "hidePromotionType11",
  12: "hidePromotionType12",
};

export const OFFERS_CONSTANTS = {
  metaData: {
    title: "Weekly Offers You Can’t Miss | Sobeys Inc.",
    description:
      "Explore the latest Sobeys offers. Enjoy great deals on fresh groceries, pantry staples, and more. Shop smarter and save today!",
  },
  heading: "Scene+ Offers",
  description:
    "Explore our exclusive offers and special discounts, designed to give you the best value on your favorite products.",
  tag: "offers",
};

export const FLYER_CONSTANTS = {
  metaData: {
    title: "Find Flyer Offers & Weekly Deals | Sobeys Inc.",
    description:
      "Our online flyers are our way of giving you the deals you want each week while giving back to our environment, too. Save by beating the paper trail.",
  },
  heading: "Flyer",
  description: "For the week of",
  tag: "flyer",
};

export const FLYER_PROMOTIONS_SOURCE = "VKA0";

export const RECIPE_NOT_EXIST_DATA = "This recipe is no longer available.";

export const ALGOLIA_ANALYTICS_TAGS = [
  process.env.NEXT_PUBLIC_BANNER || "",
  "website",
];
export const ONE_DAY_CACHE_TIME = 86400;


export const SHOPPING_LIST_NAME_DATALAYER = "Shopping List";
